/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Hero_H1_BeforeInputs */

const es_l6_hero_h1_before = /** @type {(inputs: L6_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu barco comercial, mejor `)
};

const gl_l6_hero_h1_before = /** @type {(inputs: L6_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu barco comercial, mellor `)
};

const en_l6_hero_h1_before = /** @type {(inputs: L6_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your commercial boat, better `)
};

/**
* | output |
* | --- |
* | "Your commercial boat, better" |
*
* @param {L6_Hero_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_hero_h1_before = /** @type {((inputs?: L6_Hero_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Hero_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_hero_h1_before(inputs)
	if (locale === "en") return en_l6_hero_h1_before(inputs)
	return es_l6_hero_h1_before(inputs)
});